<template>
  <div class="wl-certification-content">
    <div class="authen-hade-title clearfix">
      <h3 class="h3-text-title">
        <span>项目介绍</span>
      </h3>
      <div class="authen-hade-crumbs">
        <i class="wl-icon-zhuye1"></i>
        <span>当前位置：</span>
        <span @click="goHome">网站首页</span>
        <span>></span>
        <span>项目介绍</span>
      </div>
    </div>
    <div class="border-class-content">
      <div class="lecturer-certi-standard">
        <h3 class="h3-wl-title" v-if="introduceTitle">
          <span class="sp-title-text">{{ introduceTitle }}</span>
        </h3>
        <div
          class="exam-text-content"
          v-if="introduceContent"
          v-html="introduceContent"
        ></div>
        <div class="no-data-tip-con" v-else>
          <img src="~assets/images/the-last-new-nodata-imag.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTab: 1,
      back: require("assets/images/bg-jieshao.png"),
      TeaAuthenticaList: [],
      introduceTitle: "",
      introduceContent: "",
      certifyIdValue: "",
    };
  },
  props: {
    certifyId: {
      type: String,
      default: "",
    },
  },
  watch: {
    certifyId(val) {
      this.certifyIdValue = val;
      this.getIntroBasic();
    },
  },
  created() {
    this.certifyIdValue = this.certifyId;
    this.getIntroBasic();
  },
  methods: {
    getIntroBasic() {
      this.$http
        .post("/api/XOrg/ProjectIntroduction/getCertificateIntroduce", {
          certificateId: this.certifyIdValue,
        })
        .then((res) => {
          if (res.code > 0) {
            const { introduceTitle, introduceContent } = res.info;
            this.introduceTitle = introduceTitle;
            this.introduceContent = introduceContent;
          }
        });
    },
    goHome() {
      this.$router.push({
        name: "xHome",
      });
    },
  },
};
</script>
